import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { ArrowUp } from 'lucide-react';

function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <Button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 w-12 h-12 rounded-full bg-[#0A4D8C] hover:bg-[#083A6B] text-white shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110 p-0"
          aria-label="Fara efst"
        >
          <ArrowUp className="w-6 h-6" />
        </Button>
      )}
    </>
  );
}

export default BackToTop;
